import React, { useMemo } from 'react';
import { Widget } from 'jamespot-front-business';

import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import styled from 'styled-components';

export const UIWrapper = styled.div<{
    padding: string;
}>`
    display: flex;
    flex-direction: column;
    padding: ${(props) => props.padding};
`;

export const WidgetStylePadding = ({ uniqid, children }: { uniqid: string; children: React.ReactNode }) => {
    const styles = useAppSelector((state) => Widget.selectors.selectWidgetWrapperStyle(state, uniqid), shallowEqual);

    const initialValues = useMemo(() => {
        return {
            padding: styles && styles['padding'] ? String(styles['padding']) : '0',
        };
    }, [styles]);

    return <UIWrapper padding={initialValues.padding}>{children}</UIWrapper>;
};
